import React from "react";
import "./plans.css";

const Plans = () => {
  return (
    <div id="plansComp" className="plans">
      <h1 className="plansHeading">Choose the right plan for your needs</h1>
      <div className="cardWrapper">
        <div className="priceCard">
          <div className="priceName">
            <h2 className="priceHeading">Monthly</h2>
          </div>
          <div className="priceDetails">
            <p className="indiDetails">Price: Rs. 2295</p>
            <p className="indiDetails">24hr unlimited access</p>
            <p className="indiDetails">Locker + Bathroom</p>
            <p className="indiDetails">Trainer Advice</p>
            <p className="indiDetails">Personalized Diet plan</p>
            <p className="indiDetails">Personalized Training</p>
          </div>
        </div>

        <div className="priceCard">
          <div className="priceName">
            <h2>3 Months</h2>
          </div>
          <div className="priceDetails">
            <p className="indiDetails">Price: Rs. 6295</p>
            <p className="indiDetails">24hr unlimited access</p>
            <p className="indiDetails">Locker + Bathroom</p>
            <p className="indiDetails">Trainer Advice</p>
            <p className="indiDetails">Personalized Diet plan</p>
            <p className="indiDetails">Personalized Training</p>
          </div>
        </div>

        <div className="priceCard">
          <div className="priceName">
            <h2>6 Months</h2>
          </div>
          <div className="priceDetails">
            <p className="indiDetails">Price: Rs. 10295</p>
            <p className="indiDetails">24hr unlimited access</p>
            <p className="indiDetails">Locker + Bathroom</p>
            <p className="indiDetails">Trainer Advice</p>
            <p className="indiDetails">Personalized Diet plan</p>
            <p className="indiDetails">Personalized Training</p>
          </div>
        </div>

        <div className="priceCard">
          <div className="priceName">
            <h2>Yearly</h2>
          </div>
          <div className="priceDetails">
            <p className="indiDetails">Price: Rs. 16295</p>
            <p className="indiDetails">24hr unlimited access</p>
            <p className="indiDetails">Locker + Bathroom</p>
            <p className="indiDetails">Trainer Advice</p>
            <p className="indiDetails">Personalized Diet plan</p>
            <p className="indiDetails">Personalized Training</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Plans;
